import { render } from "./RegPage.vue?vue&type=template&id=4b468c53&scoped=true"
import script from "./RegPage.vue?vue&type=script&lang=js"
export * from "./RegPage.vue?vue&type=script&lang=js"

import "./RegPage.vue?vue&type=style&index=0&id=4b468c53&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b468c53"]])

export default __exports__